import { useEffect, useState } from "react";
import { PageHeader, Section } from "@/components/layout/Section";
import { motion } from "framer-motion";
import api from "@/lib/api";
import LeaderAvatar from "@/components/LeaderAvatar";

export default function Leadership() {
  const [leaders, setLeaders] = useState([]);
  useEffect(() => {
    api.get("/leaders").then((r) => setLeaders(r.data));
  }, []);

  return (
    <div data-testid="leadership-page">
      <PageHeader
        kicker="Leadership"
        title="Shepherds after God's own heart."
        subtitle="Our leadership team walks in humility, integrity, and a fierce commitment to Christ and His people."
      />

      <Section>
        {leaders.length === 0 ? (
          <div className="text-center text-slate-500 py-20">Leadership profiles coming soon.</div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {leaders.map((l, i) => (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.06 }}
                key={l.id}
                className="card-soft overflow-hidden"
                data-testid={`leader-card-${i}`}
              >
                <div className="aspect-[4/5] bg-royal-50 overflow-hidden">
                  {l.image ? (
                    <img src={l.image} alt={l.name} className="w-full h-full object-cover" loading="lazy" />
                  ) : (
                    <LeaderAvatar name={l.name} />
                  )}
                </div>
                <div className="p-6">
                  <div className="text-xs uppercase tracking-widest text-gold-500">{l.title}</div>
                  <h3 className="mt-2 font-serif text-2xl text-royal">{l.name}</h3>
                  {l.bio && <p className="mt-3 text-slate-600 text-sm leading-relaxed">{l.bio}</p>}
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </Section>
    </div>
  );
}
